export default "__VITE_ASSET__BN3JVGgk__"